import { Box, Card, CardContent, Typography, Skeleton } from "@mui/material";
import { formatCurrency } from "../../helpers/financialHelpers";
import TooltipTotalCharged from "./card/TooltipTotalCharged";
import TooltipTotalReceived from "./card/TooltipTotalReceived";
import TooltipTotalPaid from "./card/TooltipTotalPaid";

const InvoiceShowCard = ({ invoice, loadingInstallmentsTable }) => {

    const WithSkeleton = ({ loading, children }) =>
        loading ? <Skeleton variant="text" width={100} sx={{ display: 'inline-block' }} /> : children;

    const installmentCount = invoice?.installments?.length || 0;
    const invoicePartsValue = invoice?.subtotal_parts_value || '';
    const invoiceServicesValue = invoice?.subtotal_services_value || '';
    const invoiceDiscount = invoice?.discount || '';
    const invoiceTotalValue = invoice?.total_value || '';
    const invoiceTotalPaidValue = invoice?.total_paid_value || '';
    const invoiceTotalReceived = invoice?.total_net_value || '';
    const invoiceIntegrated = invoice?.integrated === true;

    return (
        <>
            <Card sx={{ p: '1.5rem', width: '34rem', bgcolor: 'background.header' }}>
                <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', p: '1rem' }}>
                    <Box sx={{ m: '0.5rem', gap: '0.5rem' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography variant="body1">Subtotal Peças e Materiais </Typography>
                            <WithSkeleton loading={!invoice}>
                                <Typography variant="body1">R$ {formatCurrency(invoicePartsValue)} </Typography>
                            </WithSkeleton>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography variant="body1">Subtotal Serviços</Typography>
                            <WithSkeleton loading={!invoice}>
                                <Typography variant="body1">R$ {formatCurrency(invoiceServicesValue)} </Typography>
                            </WithSkeleton>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography variant="body1">Desconto </Typography>
                            <WithSkeleton loading={!invoice}>
                                <Typography variant="body1">- R$ {formatCurrency(invoiceDiscount)} </Typography>
                            </WithSkeleton>
                        </Box>
                    </Box>
                    <Box sx={{ m: '0.5rem', gap: '1rem', display:'flex', flexDirection:'column' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Box sx={{ display: 'flex', gap:'0.5rem'}}>
                                <Typography variant="h6">Total cobrado</Typography>
                                <TooltipTotalCharged />
                            </Box>
                            <WithSkeleton loading={!invoice}>
                                <Typography variant="h6">R$ {formatCurrency(invoiceTotalValue)}</Typography>
                            </WithSkeleton>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Box sx={{ display: 'flex', gap:'0.5rem'}}>
                                <Typography variant="h6">Total pago</Typography>
                                <TooltipTotalPaid />
                            </Box>
                            <WithSkeleton loading={!invoice || loadingInstallmentsTable}>
                                <Typography variant="h6">R$ {formatCurrency(invoiceTotalPaidValue)}</Typography>
                            </WithSkeleton>
                        </Box>
                        {invoiceIntegrated && (<Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Box sx={{ display: 'flex', gap:'0.5rem' }}>
                                <Typography variant="h6">Total recebido</Typography>
                                <TooltipTotalReceived />
                            </Box>
                            <WithSkeleton loading={!invoice || loadingInstallmentsTable}>
                                <Typography variant="h6">R$ {formatCurrency(invoiceTotalReceived)}</Typography>
                            </WithSkeleton>
                        </Box>
                        )}
                        {installmentCount > 1 && (
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography variant="body1">Parcelado em {installmentCount}x </Typography>
                            </Box>
                        )}
                    </Box>
                </CardContent>
            </Card >
        </>
    )
}

export default InvoiceShowCard;